import { AppState } from 'src/ducks';

export const __REDUX_STATE_KEY__ = 'globalSearch';

export const getReduxStateSlice = (state: AppState) => state[__REDUX_STATE_KEY__];

export const getGlobalSearch = (state: AppState) => getReduxStateSlice(state).q;
